/* Mobile smartBanner define */
(function closure(root, factory) {
  /* istanbul ignore else  */
  if (typeof define === 'function' && define.amd) {
    define('footer.pcLink', ['jquery', 'cookie-utils', 'hfConfig'],
      function load(jQuery, cookieUtils, hfConfig) {
        return factory(root, jQuery, cookieUtils, hfConfig);
      });
  } else {
    // For non-AMD module, expose this to global (will also be useful for test cases)
    /*eslint-disable*/
    var _hfapp = THD.Utility.Namespace.createNamespace('THD.HFApp');
    _hfapp.pcLink = factory(root, jQuery, cookieUtils);
    /*eslint-enable*/
  }
})(this, function factory(root, $, cookieUtils, hfConfig) {
  var module = {};


  var privateMethods = {};

  privateMethods.clickHandler = function(e) {

    e.preventDefault();

    if (hfConfig.channel === 'web' && cookieUtils.hasBrowserCookie("THD_USR_AGENT_OVERRIDE")) {
      cookieUtils.deleteBrowserCookie('THD_USR_AGENT_OVERRIDE', hfConfig.cookie_domain);
    } else if (hfConfig.channel === 'mobile') {
      cookieUtils.setCookieExpireInSeconds('THD_USR_AGENT_OVERRIDE', 'FULL', 18000, hfConfig.cookie_domain);
      cookieUtils.deleteBrowserCookie('THD_ONLINE_CHANNEL', hfConfig.cookie_domain);
      cookieUtils.deleteBrowserCookie('MOBILE_WEB', hfConfig.cookie_domain);
    }

    var pcSiteUrl = '';
    var absoluteUrlPattern = /^https?:\/\//i;
    if (typeof(hfConfig.deepLinkUrl) === 'undefined') {
      pcSiteUrl = $(this).data('href');
    } else if (!absoluteUrlPattern.test(hfConfig.deepLinkUrl)) {
      pcSiteUrl = $(this).data('href') + hfConfig.deepLinkUrl;
    } else {
      pcSiteUrl = hfConfig.deepLinkUrl;
    }

    privateMethods.linkHandler(pcSiteUrl);

  };

  /* istanbul ignore next  */
  privateMethods.linkHandler = function(url) {
    window.location.href = url;
  }

  module.init = function _init() {
    $(document).on('click', '#linkPcSite', privateMethods.clickHandler);
  };

  module.getPrivateMethods = function(){
    return privateMethods;
  };

  return module;
});
